import { combineEpics } from 'redux-observable';
import { loadCountries } from './loadCountries';

export default combineEpics(loadCountries);



// WEBPACK FOOTER //
// ./src/scenes/Countries/services/epics/index.ts